import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../helper/urls.js";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import HeaderOne from "../../masterLayout/HeaderOne";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useSelector } from "react-redux";

const Register = ({ initialData, isEdit }) => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    profileImage: "",
    firstName: initialData?.firstName || "",
    lastName: initialData?.lastName || "",
    email: initialData?.email || "",
    phone: initialData?.phone || "",
    country_code: initialData?.country_code || "",
    universityName: initialData?.universityName || "",
    satActScore: initialData?.satActScore || "",
    majorCourse: initialData?.majorCourse || "",
    interestedIn: initialData?.interestedIn || "General Counseling",
    testimony: initialData?.testimony || "",
    pricePerHour: initialData?.price_per_hour || "",
    approval_reject_date: initialData?.approval_reject_date || "",
  });

  const [imagePreviewUrl, setImagePreviewUrl] = useState(
    initialData?.profileImage || ""
  );

  useEffect(() => {
    if (initialData?.profileImage) {
      setImagePreviewUrl(initialData.profileImage);
      setFormData((prevData) => ({
        ...prevData,
        profileImage: initialData.profileImage,
      }));
    }
  }, [initialData]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
        setFormData((prevData) => ({
          ...prevData,
          profileImage: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    let phone = "";
    let country_code = "";

    try {
      const phoneNumber = parsePhoneNumber(value);
      phone = phoneNumber?.nationalNumber || "";
      country_code = `+${phoneNumber?.countryCallingCode}` || "";
    } catch {
      phone = value;
    }

    setFormData((prevData) => ({
      ...prevData,
      phone: phone,
      country_code: country_code,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const apiUrl = isEdit
      ? `${baseUrl}/api/counselors/${initialData?.id}`
      : `${baseUrl}/api/counselors/`;

    try {
      const response = await axios({
        method: isEdit ? "put" : "post",
        url: apiUrl,
        data: formData,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success(
          `${isEdit ? "Counselor updated" : "Counselor added"} successfully!`
        );
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    } catch (error) {
      error.response?.data?.errors?.forEach((err) => {
        toast.error(err.msg);
      });
      console.error(
        `Error ${isEdit ? "updating" : "adding"} counselor:`,
        error
      );
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="card h-100 p-0 mt-0 pb-0 radius-12">
        <div className="row justify-content-center">
          <div className="col-xxl-12 col-xl-12 col-lg-12">
            <div className="card border">
              <div className="card-body px-200 pt-300 pb-300">
                <h6 className="text-center">Counselor</h6>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* First Name */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Last Name */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Phone Number with Country Code */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <PhoneInput
                          international
                          defaultCountry="US"
                          value={
                            formData.country_code && formData.phone
                              ? `${formData.country_code}${formData.phone}`
                              : ""
                          }
                          onChange={handlePhoneChange}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>

                    {/* University Name */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          University Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="universityName"
                          value={formData.universityName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* SAT/ACT Score */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          SAT/ACT Score <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="satActScore"
                          value={formData.satActScore}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Price Per Hour */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          Price Per Hour <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="pricePerHour"
                          value={formData.pricePerHour}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Major Course */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">Major Course</label>
                        <input
                          type="text"
                          className="form-control"
                          name="majorCourse"
                          value={formData.majorCourse}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Interested In */}
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label className="form-label">
                          Interested In <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="interestedIn"
                          value={formData.interestedIn}
                          onChange={handleChange}
                          required
                        >
                          <option value="General Counseling">
                            General Counseling
                          </option>
                          <option value="Essay Counseling">
                            Essay Counseling
                          </option>
                          <option value="College Tour">College Tour</option>
                          <option value="College Counseling">
                            College Counseling
                          </option>
                        </select>
                      </div>
                    </div>

                    {/* Testimony */}
                    <div className="col-sm-12">
                      <div className="mb-20">
                        <label className="form-label">
                          Testimony <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          name="testimony"
                          value={formData.testimony}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center">
                    <button type="submit" className="btn btn-primary">
                      Register
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
